import DEFAULT_CONFIG from "./default_config.json"
import { merge } from "./utils"
import { getCodexCredentials } from './codexAuth.svelte.js'

export const CONFIG = $state({})

export function refreshConfig() {
  let nextConfig
  try {
    nextConfig = merge(DEFAULT_CONFIG, JSON.parse(localStorage['cfg-config-user'] || "{}"))
  } catch (error) {
    console.error('User config is not valid', error)
    alert('User config is not valid')
    nextConfig = DEFAULT_CONFIG
  }
  for (const key of Object.keys(CONFIG)) delete CONFIG[key]
  Object.assign(CONFIG, nextConfig)
  injectCodexCredentials()
  window._config = CONFIG
}

function injectCodexCredentials() {
  const api = CONFIG.apis?.codex
  if (api?.baseurl !== 'codex://') return
  const credentials = getCodexCredentials()
  CONFIG.apis = {...CONFIG.apis, codex: {
    ...api,
    proxy: location.origin !== 'http://localhost:5173',
    token: credentials?.accessToken || '',
    accountId: credentials?.accountId || '',
    expiresAt: credentials?.expiresAt || 0,
  }}
}

window.addEventListener('codex-auth-change', injectCodexCredentials)

refreshConfig()
